import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import Spinner from "../Spinner/Spinner";

import "./styles.scss";

const DisplayAiDecision = ({ aiDecision, aiDecisionLoading, generatingAiDecision }) => {
  return (
    <div
      className={`markdown-container ${
        aiDecision === "" || aiDecisionLoading || generatingAiDecision
          ? "markdown-container--center"
          : ""
      }`}>
      {aiDecisionLoading || generatingAiDecision ? (
        <div className="markdown-container__center">
          <Spinner />
        </div>
      ) : aiDecision === "" ? (
        <div className="markdown-container__center">
          <p>
            There is no generated ai decision. Click the button above to generate an ai decision.
          </p>
        </div>
      ) : (
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{aiDecision}</ReactMarkdown>
      )}
    </div>
  );
};

export default DisplayAiDecision;
